import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

const createEventBannerStyles = (bannerUrl = '') =>
  bannerUrl &&
  `
  background-image: url('${bannerUrl}');
  background-size: cover;
  background-position: center;
`

interface EventItemProps {
  $bannerUrl?: string
}

export const EventItemRoot = styled('a')`
  display: block;
  position: relative;
  width: 100%;
  background-color: ${colors.lightGrey2};
  text-decoration: none;
  color: ${colors.black};
  margin-bottom: 16px;
  ${({ $bannerUrl }: EventItemProps) => createEventBannerStyles($bannerUrl)}

  &::before {
    content: '';
    display: block;
    padding-top: ${(146 / 285) * 100}%;
  }
`

export const EventItemInner = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const EventItemNameWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const EventItemName = styled(Box)`
  text-align: center;
  width: 80%;
  font-size: 20px;
`

export const EventItemMessageWrapper = styled(Box)`
  position: absolute;
  bottom: 12px;
  left: -8px;
  display: inline-block;
  max-width: calc(100% - 31px);
  overflow: hidden;
  background-color: ${colors.darkGray3};
  padding: 11px 16px;
  z-index: 10;
`

export const EventItemMessage = styled(Box)`
  color: ${colors.white};
  line-height: 1.25;
  font-size: 16px;
  overflow: hidden;
`
